import { Link } from "react-router-dom";
import { blogPosts } from "../../data/blogPosts";

export default function BlogIndex() {
  return (
    <div className="container">
      <h1>Blog</h1>
      <p>Guides, comparisons, and practical tips.</p>

      <div className="grid">
        {blogPosts.map((p) => (
          <article key={p.slug} className="card">
            <Link to={`/blog/${p.slug}`}>
              <img src={p.heroImage} alt={p.heroImageAlt} className="card__img" />
              <h2 className="card__title">{p.title}</h2>
            </Link>
            <p className="card__meta">
              {new Date(p.publishedAt).toLocaleDateString()} · {p.category}
            </p>
            <p>{p.metaDescription}</p>
          </article>
        ))}
      </div>
    </div>
  );
}